import * as z from "zod";
import { code, decimal, pagination } from "../index";
import { soStatuses } from "./enums";

// Spec v0.3 §9, "Ordini per stagione e stato" (P5.11d, ADR-261): the orders counted by season, brand, customer and
// status, with their units and their value. A view of Tomorrow, served by sales.

export const listSalesOrderTotalsInput = z.object({
  /** Code of the season. */
  season: code.optional(),
  brand: z.uuid().optional(),
  customer: z.uuid().optional(),
  status: z.enum(soStatuses).optional(),
  ...pagination({ defaultSize: 50, maxSize: 200 }),
});
export type ListSalesOrderTotalsInput = z.input<typeof listSalesOrderTotalsInput>;

/**
 * The orders of a customer for a brand in a season and a status, in one currency (a value in two currencies is not one
 * sum): how many, their units ordered, allocated and shipped, and what they are worth. Cancelled lines are out.
 */
export const salesOrderTotalDto = z
  .object({
    /** Code of the season. */
    season: z.string().nullable(),
    brandOrgId: z.uuid().nullable(),
    brand: z.string().nullable(),
    customerOrgId: z.uuid(),
    customer: z.string(),
    status: z.enum(soStatuses),
    currency: z.string(),
    salesOrderCount: z.number().int(),
    qtyOrdered: z.number().int(),
    qtyAllocated: z.number().int(),
    qtyFulfilled: z.number().int(),
    /** What they ordered after the discounts; the field rule that hides the amount of an order hides it here too. */
    totalAmount: decimal.optional(),
  })
  .meta({ id: "SalesOrderTotal" });
export type SalesOrderTotalDto = z.output<typeof salesOrderTotalDto>;
